import React, { useEffect, useId, useRef, useState } from 'react';
import moment from 'moment';
import { OverlayTrigger, Tooltip } from 'react-bootstrap';
import { parsePlanningTitle, getPlanningManpower, getPlanningTargetOutput } from './planningCalendar';

export default function PlanningJobTooltip({ event, children, disabled = false }) {
    const id = useId();
    const [show, setShow] = useState(false);
    useEffect(() => {
        if (disabled) setShow(false);
    }, [disabled]);
    const ignoreRestoredFocus = useRef(false);
    const child = React.Children.only(children);
    const parsed = parsePlanningTitle(event.title);
    const machine = String(event.machineNo || '').trim() || String(event.lineNo || '').trim();
    return (
        <OverlayTrigger
            placement="auto"
            show={show && !disabled}
            onToggle={nextShow => setShow(!disabled && nextShow)}
            overlay={
                <Tooltip id={`planning-job-${id}`} className="planning-job-tooltip">
                    <strong>{parsed.displayTitle || 'Untitled job'}</strong>
                    {parsed.closed && <div>CLOSED</div>}
                    <div>Machine / line: {machine || 'Unassigned'}</div>
                    <div>Start: {moment(event.start).format('DD/MM/YYYY h:mm A')}</div>
                    <div>End: {moment(event.end).format('DD/MM/YYYY h:mm A')}</div>
                    <div>Manpower: {event.metricsPending ? 'Loading…' : getPlanningManpower(event) ?? '—'}</div>
                    <div>Target output: {event.metricsPending ? 'Loading…' : getPlanningTargetOutput(event)}</div>
                    {event.hasProductionData && <div>Deletion unavailable: production data submitted.</div>}
                </Tooltip>
            }
        >
            {React.cloneElement(child, {
                onClick: clickEvent => {
                    // Closing the job modal restores focus to this button.
                    ignoreRestoredFocus.current = true;
                    setShow(false);
                    child.props.onClick?.(clickEvent);
                },
                onFocus: focusEvent => {
                    if (ignoreRestoredFocus.current) {
                        ignoreRestoredFocus.current = false;
                        setShow(false);
                    }
                    child.props.onFocus?.(focusEvent);
                },
            })}
        </OverlayTrigger>
    );
}
